import { useStoreItem } from '@/features/theme-editor/hooks/useStoreItem';
import { useCustomizationStore } from '@/features/theme-editor/stores/customizationStore';
import { ItemType, StoreItem } from '@/features/theme-editor/types/store';
import { EditorialTextData, GalleryData, SectionData, SectionType, TestimonialsData } from '@/types/store';
import { useEffect } from 'react';
import { MenuItem, useMenuNavigation } from '../../Menu';
import { Icon } from '../../ui/Icon';
import { EditorialText } from './EditorialText';
import { Gallery } from './Gallery';
import { Testimonials } from './Testimonials';
import { Title } from './Title';

export interface Props {
    id: number;
}

export const AddBlock = ({ id }: Props) => {
    const { updateItem } = useCustomizationStore();
    const { push } = useMenuNavigation();
    const item = useStoreItem(id);

    useEffect(() => {
        if (item?.type !== ItemType.PENDING) {
            updateItem({
                ...item,
                type: ItemType.PENDING,
                data: {},
            } as StoreItem);
        }
    }, []);

    return (
        <div className='w-full p-4'>
            <ul className='w-full space-y-2'>
                <MenuItem
                    label='Title'
                    icon={<Icon name='title' />}
                    description='Insert a heading to separate and define store sections'
                    onClick={() => {
                        updateItem({
                            ...item,
                            type: SectionType.TITLE,
                            data: { title: 'New Section' } as SectionData,
                        } as StoreItem);
                        push('Title', <Title id={id} />);
                    }}
                />

                <MenuItem
                    label='Editorial Text'
                    icon={<Icon name='editorial-text' />}
                    description='Highlight words that inspire or define your brand.'
                    onClick={() => {
                        updateItem({
                            ...item,
                            type: SectionType.EDITORIAL_TEXT,
                            data: {
                                editorial_text: {
                                    primary_text: 'A short paragraph of large text',
                                    secondary_text: 'With complementary text',
                                },
                            } as EditorialTextData,
                        } as StoreItem);
                        push('Editorial Text', <EditorialText id={id} />);
                    }}
                />

                <MenuItem
                    label='Gallery'
                    icon={<Icon name='gallery' />}
                    description='Display multiple images in a clean, scrollable view.'
                    onClick={() => {
                        updateItem({
                            ...item,
                            type: SectionType.GALLERY,
                            data: { gallery: { images: [] } } as GalleryData,
                        } as StoreItem);
                        push('Gallery', <Gallery id={id} />);
                    }}
                />

                <MenuItem
                    label='Testimonials'
                    icon={<Icon name='testimonial' />}
                    description='Build trust with real customer voices.'
                    onClick={() => {
                        updateItem({
                            ...item,
                            type: SectionType.TESTIMONIALS,
                            data: { title: 'Reviews & Testimonials', testimonials: { testimonials: [] } } as TestimonialsData,
                        } as StoreItem);
                        push('Testimonials', <Testimonials id={id} />);
                    }}
                />
            </ul>
        </div>
    );
};
